// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"b7ff6f31","203":"5f3be54f","474":"86b12f8e","494":"8356db11","513":"ceac5ec1","544":"876fc819","677":"6b8b3302"}[chunkId] + ".chunk.css";
};